import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SuperHttpClientProvider } from '@app/core/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

export interface WeeklyReportScopeResponse {
  clientIds?: number[];
  fincaIds?: number[];
  moduleIds?: number[];
}

export interface WeeklyReportSubscriptionRecord {
  idWeeklyReportSubscription?: number;
  isEnabled?: boolean;
  enabled?: boolean;
  plan?: string;
  scopeType?: string;
  sendDay?: string;
  sendTime?: string;
  timezone?: string;
  language?: string;
}

export interface WeeklyReportSubscriptionResponse {
  subscription: WeeklyReportSubscriptionRecord | null;
  scope?: WeeklyReportScopeResponse;
}

export interface WeeklyReportSubscriptionPayload {
  enabled: boolean;
  plan: string;
  scopeType: string;
  sendDay: string;
  sendTime: string;
  timezone: string;
  language: string;
  clientIds?: number[];
  fincaIds?: number[];
  moduleIds?: number[];
}

@Injectable({
  providedIn: 'root'
})
export class WeeklyReportSubscriptionService {
  constructor(
    private $http: SuperHttpClientProvider,
    private http: HttpClient
  ) {}

  getSubscriptionByUser(
    userId: number
  ): Observable<WeeklyReportSubscriptionResponse> {
    return this.$http.default.get(
      `/admin/weekly-report/subscription/user/${userId}`
    );
  }

  upsertSubscriptionByUser(
    userId: number,
    payload: WeeklyReportSubscriptionPayload
  ): Observable<any> {
    return this.$http.default.post(
      `/admin/weekly-report/subscription/user/${userId}`,
      payload
    );
  }

  previewPayload(
    subscriptionId: number,
    weekStart?: string | null
  ): Observable<any> {
    let params = new HttpParams();
    if (weekStart) {
      params = params.set('weekStart', weekStart);
    }
    return this.$http.default.get(
      `/admin/weekly-report/subscription/${subscriptionId}/payload-preview`,
      { params }
    );
  }

  runSubscription(
    subscriptionId: number,
    payload: { weekStart?: string | null; force?: boolean }
  ): Observable<any> {
    return this.$http.default.post(
      `/admin/weekly-report/subscription/${subscriptionId}/run`,
      payload
    );
  }

  previewRunHtml(runId: number): Observable<string> {
    return this.http.get(
      `${environment.serverUrl}/admin/weekly-report/run/${runId}/html-preview`,
      { responseType: 'text' }
    );
  }

  generateRunPdf(runId: number): Observable<any> {
    return this.$http.default.post(
      `/admin/weekly-report/run/${runId}/generate-pdf`,
      {}
    );
  }

  downloadRunPdf(runId: number): Observable<Blob> {
    return this.http.get(
      `${environment.serverUrl}/admin/weekly-report/run/${runId}/download-pdf`,
      { responseType: 'blob' }
    );
  }

  sendRunEmail(runId: number): Observable<any> {
    return this.$http.default.post(
      `/admin/weekly-report/run/${runId}/send-email`,
      {
        force: true
      }
    );
  }

  getAvailableClients(): Observable<any[]> {
    return this.$http.default.get('/admin/cliente');
  }

  getAvailableModules(): Observable<any[]> {
    return this.$http.default.get('/admin/module');
  }
}
